import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function FormAlert({
  route = "/account",
  message = "Form is submitted successfully",
  description = "Complete breakup is available in Pay page",
  buttonText = "Go to Pay",
}) {
  const navigate = useNavigate();
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,
          border: "1px solid #c8e6c9",
          bgcolor: "#f1f8e9",
          textAlign: "center",
        }}
      >
        <CheckCircle sx={{ fontSize: 56, color: "#4caf50", mb: 2 }} />
        <Typography variant="h6" fontWeight={700} gutterBottom>
          {message}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {description}
          </Typography>
        )}
        <Button
          variant="contained"
          onClick={() => navigate(route)}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
            color: "#1a237e",
            fontWeight: 600,
            px: 4,
          }}
        >
          {buttonText}
        </Button>
      </Paper>
    </Container>
  );
}
